<template>    
    <div class="card course" :class="{
        'featured': (highlightFeatured && course.is_featured),
        'past': isPast
    }">

        <div class="card-body">
            <a :href="course.uri">
                <img class="card-img-top-virtuoso" :src="course.imageUris ? course.imageUris.cardThumb.url : ''" :alt="course.name" loading="lazy">
            </a>
            
            <a :href="course.uri">
                <h2 class="card-title">{{ course.name }}</h2>
            </a>

            <hr>
            
            <p class="card-text">{{ course.description_short }}</p>

            <p class="card-text">
                {{ course.classNum }} {{ course.classNum > 1 ? 'classes' : 'class' }}<br>
                From: {{ course.fromPriceFormatted }}
                <template v-if="dateset">
                    <br>
                    {{ dateset.startDateFormatted }} - {{ dateset.endDateFormatted }}
                </template>
            </p>

            <div class="row no-gutters btn-area">
                <div class="col">
                    <a :href="course.uri" class="btn btn-primary btn-main">Find Out More</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            courseData: {
                type: Object,
                default: null
            },
            dateset: {
                type: Object,
                default: null,
                required: false,
            },
            highlightFeatured: {
                type: Boolean,
                default: true
            },
            isPast: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                course: {},
            }
        },

        mounted() {
            if(this.courseData) {
                this.course = this.courseData;
            } else {
                this.getCourse();
            }
        },

        methods: {
            getCourse: function() {
                axios.get('/api/courses/' + this.id)
                    .then((response) => {
                        this.course = response.data;
                    });
            }
        }
    }
</script>
